import { getHistory } from '../routing/history';
export const getHistoryForTracking = () => {
  return getHistory();
};